// JavaScript Document

// Scripts written by Jordan Bearce @ Weblinx, Inc.

const TOGGLES = document.querySelectorAll(".weblinx-panel-toggle");

TOGGLES.forEach((toggle) => {
    toggle.addEventListener("weblinx/panel/toggles", (e) => {
        if (e.detail.expanded) {
            if (e.detail.panel.classList.contains("weblinx-panel--navigation")) {
                e.detail.panel.querySelector("a").focus();
            } else if (e.detail.panel.classList.contains("weblinx-panel--search")) {
                e.detail.panel.querySelector("input[type='search']").focus();
            }
        }
    });
});
